import { render, staticRenderFns } from "./NewTeam.vue?vue&type=template&id=a904c1a2&scoped=true&"
import script from "./NewTeam.vue?vue&type=script&lang=js&"
export * from "./NewTeam.vue?vue&type=script&lang=js&"
import style0 from "./NewTeam.vue?vue&type=style&index=0&id=a904c1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a904c1a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VDivider,VIcon})
